export default __webpack_public_path__ + "static/media/partners-card-mobile.a3e87598.png";